import { BadgeOwnProps } from '@mui/material/Badge';
import { FaultType } from 'shared/enums/fault-type';

const residentSettingsDeviceStatus = (faults: FaultType[]): BadgeOwnProps['color'] => {
  if (
    faults.some(
      (fault) =>
        fault === FaultType.BatteryCritical ||
        fault === FaultType.GatewayDown ||
        fault === FaultType.Offline ||
        fault === FaultType.OutDated,
    )
  ) {
    return 'error';
  }

  if (faults.some((fault) => fault === FaultType.BatteryLow)) {
    return 'warning';
  }

  return 'primary';
};

export default residentSettingsDeviceStatus;
